<template>
  <div>
    <DataFetcher
      dataKey="activeDelivery"
      ref="activeDeliveryGetter"
      :debounceDelay="0"
      :filters="{ requestMethod: 'post' }"
      @fetched="
        ({ data }) => {
          activeDeliveryData = data
        }
      "
    >
      <template
        #any="{
          loading: activeDeliveryLoading,
          loadingError: activeDeliveryLoadingError,
          refresh: refreshActiveDelivery,
          result: activeDeliveryResult,
        }"
      >
        <div>
          <div
            :class="{
              shimmerContainer: activeDeliveryLoading || acceptingOrder,
            }"
            ref="scrollableContent"
            class="noSaturate fixed bottom-0 w-full h-full overflow-auto flex flex-col rounded-t-3xl"
          >
            <div class="[&_.mapContainer]:!fixed">
              <Map ref="mapRef" />
            </div>

            <div
              class="flex justify-between poiner-events-none p-5 items-center fixed z-10 w-full top-0 gap-3 mobile-margin-top"
            >
              <div>
                <div class="rounded-full pointer-events-auto relative">
                  <div
                    class="absolute w-full h-full liquidGlassCard rounded-full"
                  ></div>
                  <div
                    class="h-10 px-5 flex items-center justify-center whitespace-nowrap title-color gap-3 relative"
                  >
                    <div class="">
                      <div
                        v-if="activeDeliveryData?.hasActiveDelivery"
                        class="relative"
                      >
                        <div
                          class="absolute w-full h-full bg-green-500/30 rounded-full animate-[ping2_6s_ease-in-out]"
                        ></div>
                        <div
                          class="relative w-6 h-6 rounded-full border-white border-4 bg-green-500"
                        ></div>
                      </div>
                      <div v-else class="relative">
                        <div
                          class="absolute w-full h-full bg-red-500/30 rounded-full animate-[ping2_6s_ease-in-out]"
                        ></div>
                        <div
                          class="relative w-6 h-6 rounded-full border-white border-4 bg-red-400"
                        ></div>
                      </div>
                    </div>
                    <div>
                      {{
                        activeDeliveryData?.hasActiveDelivery
                          ? 'En course'
                          : 'Pas en course'
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex gap-0">
                <router-link
                  to="/performance"
                  class="rounded-full pointer-events-auto border"
                >
                  <Progress />
                  <div
                    class="h-10 p-2 z-[1] relative liquidGlassCard rounded-full text-transparent"
                  >
                    <div class="w-[4ch] text-center">20%</div>
                  </div>
                </router-link>
                <div
                  class="relative flex items-center justify-center w-0 z-[0]"
                >
                  <div
                    class="w-12 min-w-12 liquidGlassCard h-[40%] border-none opacity-0"
                  ></div>
                </div>
                <div
                  class="relative flex items-center justify-center w-0 z-[2]"
                >
                  <div
                    class="min-w-5 rounded-full h-[45%] backdrop-blur-md"
                  ></div>
                </div>

                <router-link
                  to="/profile"
                  class="liquidGlassCard rounded-full pointer-events-auto -ml-[3px]"
                >
                  <div
                    class="h-10 px-5 flex items-center justify-center whitespace-nowrap title-color"
                  >
                    Hello {{ Storage.get('userData')?.firstName }}
                  </div>
                </router-link>
                <button
                  @click="openChatWithSupport"
                  class="ripple liquidGlassCard rounded-full pointer-events-auto ml-2 overflow-hidden"
                >
                  <div class="w-10 title-color h-10 p-2">
                    <ColorImg
                      class="w-full h-full bg-current"
                      src="/images/icons/chatNotif.svg"
                      alt=" "
                    />
                  </div>
                </button>
              </div>
            </div>
            <div
              class="flex justify-center p-5 items-center pointer-events-none fixed w-full top-14 gap-3 mobile-margin-top"
              v-if="activeDeliveryData?.hasActiveDelivery"
            >
              <button
                class="rounded-full pointer-events-auto relative liquidGlassCard ripple !shadow-xl shadow-[red] !border-red-500"
                @click="openEmergencySosDialog"
              >
                <div
                  class="py-2 px-4 flex items-center justify-center whitespace-nowrap text-red-400 text-2xl font-bold gap-3 relative drop-shadow-md"
                >
                  <div class="w-6 h-6">
                    <ColorImg
                      class="w-full h-full bg-current"
                      src="/images/icons/alerte.svg"
                      alt=" "
                    />
                  </div>
                  <div>Signaler une urgence</div>
                </div>
              </button>
            </div>

            <div
              class="p-5 bottom-0 absolute w-full"
              v-if="activeDeliveryLoadingError"
            >
              <div
                class="rounded-3xl liquidGlassCard pointer-events-auto w-full"
              >
                <NoDataView
                  :result="activeDeliveryResult"
                  :refresh="refreshActiveDelivery"
                ></NoDataView>
              </div>
            </div>
            <div
              class="mt-auto p-4 sticky top-0 flex justify-center items-center gap-2 right-0 w-full mb-4"
            >
              <div
                class="pointer-events-auto absolute"
                v-if="
                  activeDeliveryData?.hasActiveDelivery &&
                  !activeDeliveryLoading &&
                  !acceptingOrder
                "
              >
                <button
                  class="buttonComponent py-2 text-xl"
                  @click="openGoogleMaps"
                >
                  Google Map
                  <!-- → -->
                  ⇒
                  {{
                    activeDeliveryData?.delivery?.nextDestination == 'pickup'
                      ? 'Départ'
                      : activeDeliveryData?.delivery?.nextDestination ==
                          'pickupDone'
                        ? 'Départ'
                        : activeDeliveryData?.delivery?.nextDestination ==
                            'checkpoint_reach'
                          ? 'Point de livraison'
                          : activeDeliveryData?.delivery?.nextDestination ==
                              'checkpoint_deliver'
                            ? 'Point de livraison'
                            : 'Destination'
                  }}
                </button>
              </div>
              <button
                class="pointer-events-auto right-4 text-primary liquidGlassCard rounded-full shadow-md absolute"
              >
                <div
                  class="ripple p-2"
                  @click="
                    () => {
                      mapRef.centerOnUser()
                    }
                  "
                >
                  <ColorImg
                    src="/images/icons/target.svg"
                    class="w-10 h-10 bg-current"
                  ></ColorImg>
                </div>
              </button>
            </div>
            <div
              v-if="!activeDeliveryLoadingError"
              class="p-4 sticky top-16 pointer-events-auto"
            >
              <div class="rounded-3xl p-5 py-6 relative">
                <div
                  class="absolute w-full h-full liquidGlassCard rounded-3xl top-0 left-0"
                ></div>
                <div class="relative">
                  <div
                    class="grid grid-cols-3"
                    v-if="activeDeliveryData?.hasActiveDelivery"
                  >
                    <div class="col-span-2 flex flex-col gap-1">
                      <div class="py-2 min-h-[50%]">
                        <div
                          v-if="
                            activeDeliveryData?.delivery?.nextDestination
                              ?.customerName ||
                            activeDeliveryData?.delivery?.customerName
                          "
                          class="mb-2"
                        >
                          <div
                            class="text-xs text-gray-500 flex justify-between items-center"
                          >
                            <span>Client / Contact</span>
                            <span
                              v-if="activeDeliveryData.delivery?.orderReference"
                              class="bg-primary text-white px-3 py-1 rounded-md font-mono font-bold text-sm shadow-sm border border-white/20"
                            >
                              #{{ activeDeliveryData.delivery.orderReference }}
                            </span>
                          </div>
                          <div class="title-color font-bold">
                            {{
                              activeDeliveryData?.delivery?.nextDestination
                                ?.customerName ||
                              activeDeliveryData?.delivery?.customerName
                            }}
                          </div>
                        </div>
                        <div
                          class="grid grid-cols-3 gap-5 shimmerTarget rounded-lg"
                        >
                          <div
                            class="col-span-2 h-full flex flex-col justify-center"
                          >
                            <div
                              v-if="
                                activeDeliveryData.delivery?.packageDescription
                              "
                              class="text-sm text-gray-600 mb-2 line-clamp-2"
                            >
                              {{
                                activeDeliveryData.delivery.packageDescription
                              }}
                            </div>
                            <RoutePointsItems
                              truncate
                              :delivery="activeDeliveryData?.delivery"
                            />
                          </div>
                          <div class="flex flex-col justify-center gap-2">
                            <div>
                              <div class="text-xs">Distance</div>
                              <div class="title-color">
                                {{
                                  activeDeliveryData?.delivery?.distanceKm ||
                                  '-'
                                }}Km
                              </div>
                            </div>
                            <div>
                              <div class="text-xs">Durée</div>
                              <div class="title-color">
                                {{
                                  activeDeliveryData?.delivery
                                    ?.estimatedDurationMin || '-'
                                }}min
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="py-2">
                        <div class="shimmerTarget rounded-lg mb-1">
                          Temps Effectué
                        </div>
                        <div
                          class="shimmerTarget rounded-lg title-color text-xl"
                        >
                          <span
                            class="font-bold"
                            v-if="
                              !activeDeliveryData?.delivery?.destinationReached
                            "
                          >
                            {{
                              Time.since(
                                activeDeliveryData?.delivery?.assignedAt,
                                { format: 'HH:mm:ss' },
                              )
                            }}
                          </span>
                          <span class="font-bold" v-else>
                            {{
                              Time.between(
                                activeDeliveryData?.delivery?.assignedAt,
                                activeDeliveryData?.delivery
                                  ?.destinationReachedAt,
                                { format: 'HH:mm:ss' },
                              )
                            }}
                          </span>
                          /
                          {{
                            activeDeliveryData?.delivery
                              ?.estimatedDurationMin || '-'
                          }}min
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-span-1 flex flex-col items-center justify-center"
                    >
                      <div
                        class="shimmerTarget rounded-lg title-color text-center font-bold"
                      >
                        Contacter le client
                      </div>
                      <div class="flex gap-3 justify-center title-color">
                        <div class="rounded-full shimmerTarget relative">
                          <button
                            @click="openOrderChat(activeDeliveryData?.delivery)"
                            class="p-3 rounded-full ripple bg-primary shadow relative"
                          >
                            <ColorImg
                              src="/images/icons/chat.png"
                              class="h-10 w-10 object-cover bg-white"
                              alt=""
                            />
                            <span
                              v-if="activeOrderUnreadCount > 0"
                              class="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-bold rounded-full h-5 min-w-[20px] px-1 flex items-center justify-center border-2 border-white shadow pointer-events-none z-10"
                            >
                              {{
                                activeOrderUnreadCount > 99
                                  ? '99+'
                                  : activeOrderUnreadCount
                              }}
                            </span>
                          </button>
                        </div>
                        <div class="rounded-full shimmerTarget">
                          <a
                            :href="`tel:${
                              activeDeliveryData?.delivery?.nextDestination
                                ?.customerPhoneNumber ||
                              activeDeliveryData?.delivery?.customerPhoneNumber
                            }`"
                            class="inline-block p-3 rounded-full ripple bg-white shadow"
                          >
                            <ColorImg
                              src="/images/icons/phone.png"
                              class="h-10 w-10 object-cover bg-current"
                              alt=""
                            />
                          </a>
                        </div>
                      </div>
                      <div
                        class="shimmerTarget text-center mt-5 rounded-lg ripple"
                        v-if="
                          activeDeliveryData?.delivery?.nextDestination
                            ?.customerPhoneNumber ||
                          activeDeliveryData?.delivery?.customerPhoneNumber
                        "
                        @click="
                          Copy.toClipboard(
                            activeDeliveryData?.delivery?.nextDestination
                              ?.customerPhoneNumber ||
                              activeDeliveryData?.delivery?.customerPhoneNumber,
                            'Numéro du client copié',
                          )
                        "
                      >
                        <div>Téléphone</div>
                        <div
                          class="flex gap-2 title-color font-bold justify-center"
                        >
                          <div class="first-letter:uppercase">
                            {{
                              activeDeliveryData?.delivery?.nextDestination
                                ?.customerPhoneNumber ||
                              activeDeliveryData?.delivery?.customerPhoneNumber
                            }}
                          </div>
                          <div>
                            <ColorImg
                              src="/images/icons/copy.png"
                              class="bg-current w-6 h-6"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="activeDeliveryData?.delivery?.restaurantPhone"
                        class="mt-4 border-t pt-4 w-full flex flex-col items-center"
                      >
                        <div
                          class="text-xs title-color text-center font-bold mb-2"
                        >
                          Restaurant
                        </div>
                        <a
                          :href="`tel:${activeDeliveryData.delivery.restaurantPhone}`"
                          class="p-3 rounded-full ripple bg-white shadow"
                        >
                          <ColorImg
                            src="/images/icons/phone.png"
                            class="h-5 w-5 object-cover bg-current"
                            alt=""
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-else class="grid grid-cols-2">
                    <div>
                      <BalanceView />
                    </div>
                    <div>
                      <BalanceStats />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="!activeDeliveryLoadingError"
              class="pointer-events-auto h-[0px]"
            >
              <div
                class="relative duration-300 overflow-hidden"
                :class="{
                  'max-h-0 min-h-0 ease-out':
                    !itemDetail || activeDeliveryData?.hasActiveDelivery,
                  'min-h-[0vh] max-h-[100vh] ease-in delay-300':
                    !!itemDetail && !activeDeliveryData?.hasActiveDelivery,
                }"
              >
                <div class="">
                  <div
                    v-if="
                      selectedTab == 'orders' || selectedTab == 'ordersDone'
                    "
                  >
                    <div class="rounded-t-3xl bg-[#ff9239]">
                      <div class="px-5 mb-5 p-5 pb-12">
                        <div
                          class="text-white flex items-center gap-2 text-3xl mb-4"
                        >
                          <div>
                            <ColorImg
                              src="/images/icons/route.png"
                              class="w-8 h-8 bg-current"
                            ></ColorImg>
                          </div>
                          <div class="font-bold">
                            {{ itemDetail?.distanceKm || '6.7' }}Km
                            {{
                              selectedTab == 'ordersDone'
                                ? 'parcourus'
                                : 'à parcourir'
                            }}
                          </div>
                        </div>
                        <div class="px-1 mb-2 text-white">Parcours</div>
                        <div
                          class="text-white"
                          :class="{
                            '[&_*]:text-primary-100':
                              selectedTab == 'ordersDone',
                            '[&_*]:text-white': selectedTab == 'orders',
                          }"
                        >
                          <RoutePointsItems
                            truncate
                            :delivery="itemDetail"
                            noLineThrough
                          />
                        </div>

                        <!-- ID Commande pour détails pré-acceptation -->
                        <div
                          v-if="itemDetail?.orderReference"
                          class="mt-4 px-1 flex justify-between items-center bg-white p-3 rounded-xl text-primary shadow-lg border-2 border-primary/20"
                        >
                          <div
                            class="text-[10px] font-black uppercase tracking-wider"
                          >
                            ID COMMANDE
                          </div>
                          <div class="font-mono font-black text-2xl">
                            #{{ itemDetail.orderReference }}
                          </div>
                        </div>

                        <!-- Nom du Client (Pré-acceptation) -->
                        <div v-if="itemDetail?.customerName" class="mt-4 px-1">
                          <div
                            class="text-white text-xs font-bold uppercase mb-1 opacity-80"
                          >
                            Client
                          </div>
                          <div class="text-white text-xl font-bold">
                            {{ itemDetail.customerName }}
                          </div>
                        </div>

                        <!-- Détails de la commande (Items & Drinks) -->
                        <div
                          v-if="
                            itemDetail?.items?.length ||
                            itemDetail?.drinks?.length
                          "
                          class="mt-4 px-1"
                        >
                          <div
                            class="text-white text-xs font-bold uppercase mb-2"
                          >
                            Contenu de la commande
                          </div>
                          <div class="flex flex-col gap-2">
                            <div
                              v-for="item in itemDetail.items"
                              :key="item.id"
                              class="flex justify-between text-white bg-white/10 p-2 rounded-lg"
                            >
                              <div>
                                {{ item.name || item.itemName || item.title }}
                              </div>
                              <div class="font-bold">
                                x{{ item.quantity || 1 }}
                              </div>
                            </div>
                            <div
                              v-for="drink in itemDetail.drinks"
                              :key="drink.id"
                              class="flex justify-between text-white bg-white/10 p-2 rounded-lg border-l-4 border-blue-400"
                            >
                              <div>{{ drink.name || drink.itemName }}</div>
                              <div class="font-bold">
                                x{{ drink.quantity || 1 }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Instructions -->
                        <div
                          v-if="itemDetail?.destinationInstructions"
                          class="mt-4 px-1"
                        >
                          <div
                            class="text-white text-xs font-bold uppercase mb-1"
                          >
                            Instructions client
                          </div>
                          <div
                            class="text-white italic bg-black/10 p-3 rounded-lg text-sm"
                          >
                            "{{ itemDetail.destinationInstructions }}"
                          </div>
                        </div>
                        <!-- Paiement & Commission -->
                        <div
                          v-if="itemDetail?.riderId"
                          class="mt-6 grid grid-cols-2 gap-4"
                        >
                          <div class="bg-white/20 p-3 rounded-2xl text-white">
                            <div class="text-[10px] uppercase opacity-80">
                              À collecter
                            </div>
                            <div class="text-xl font-bold">
                              {{
                                itemDetail?.paymentAmount
                                  ? Commons.formatNumber(
                                      itemDetail.paymentAmount,
                                      {
                                        suffix:
                                          ' ' + itemDetail.paymentCurrency,
                                      },
                                    )
                                  : 'Déjà payé'
                              }}
                            </div>
                            <div class="text-[10px] italic">
                              {{
                                itemDetail?.paymentMode == 'cash'
                                  ? 'Espèces'
                                  : 'Portefeuille/Ligne'
                              }}
                            </div>
                          </div>
                          <div class="bg-white/20 p-3 rounded-2xl text-white">
                            <div class="text-[10px] uppercase opacity-80">
                              Votre Gain
                            </div>
                            <div class="text-xl font-bold">
                              {{
                                Commons.formatNumber(
                                  itemDetail?.riderCommission || 0,
                                  { suffix: ' ' + itemDetail?.paymentCurrency },
                                )
                              }}
                            </div>
                            <div class="text-[10px] italic">
                              Commission Rapidoo
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div
                        v-for="checkpoint in itemDetail?.checkpoints ||[]  "
                      >
                      dd {{checkpoint}}
                        {{ resolveCheckpointCode(itemDetail, checkpoint) }}
                      </div> -->
                      <div class="bg-white p-5 rounded-t-3xl -mt-5">
                        <button
                          class="w-full buttonComponent mb-5"
                          v-if="
                            !itemDetail?.riderId &&
                            itemDetail?.status !== 'canceled'
                          "
                          @click="acceptOrder(itemDetail)"
                        >
                          Accepter cette course
                        </button>
                        <button
                          class="w-full buttonComponent bg-slate-100 text-primary border border-primary"
                          @click="exitOrderDetail()"
                        >
                          Retour
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="duration-300 overflow-hidden"
                :class="{
                  'max-h-0 min-h-0':
                    !activeDeliveryData?.hasActiveDelivery &&
                    !activeDeliveryLoading &&
                    !acceptingOrder,
                  'max-h-[70vh] delay-300 min-h-10':
                    activeDeliveryData?.hasActiveDelivery &&
                    !activeDeliveryLoading &&
                    !acceptingOrder,
                }"
              >
                <div
                  class="rounded-t-3xl w-full absolute !border-b-0 !rounded-b-none liquidGlassCard duration-300"
                  v-if="
                    activeDeliveryData?.hasActiveDelivery &&
                    !activeDeliveryLoading &&
                    !acceptingOrder
                  "
                >
                  <div class="p-5">
                    <div class="px-5 mb-5">
                      <div class="flex justify-between items-center">
                        <div class="title-color px-1 mb-2 text-xl">
                          Parcours
                        </div>
                        <!-- <button
                          class="buttonComponent py-2"
                          @click="openGoogleMaps"
                        >
                          Google Map
                        </button> -->
                      </div>
                      <RoutePointsItems
                        :delivery="activeDeliveryData?.delivery"
                      />
                    </div>

                    <!-- Détails pour Course Active (Items & Paiement) -->
                    <div
                      class="px-5 mb-5 border-t pt-4"
                      v-if="
                        activeDeliveryData?.delivery?.items?.length ||
                        activeDeliveryData?.delivery?.drinks?.length
                      "
                    >
                      <div class="title-color text-xs font-bold uppercase mb-2">
                        Articles à récupérer
                      </div>
                      <div class="flex flex-col gap-2">
                        <div
                          v-for="item in activeDeliveryData.delivery.items"
                          :key="item.id"
                          class="flex justify-between bg-gray-50 p-2 rounded-lg border border-gray-100"
                        >
                          <div class="title-color text-sm">
                            {{ item.name || item.itemName || item.title }}
                          </div>
                          <div class="font-bold text-primary">
                            x{{ item.quantity || 1 }}
                          </div>
                        </div>
                        <div
                          v-for="drink in activeDeliveryData.delivery.drinks"
                          :key="drink.id"
                          class="flex justify-between bg-blue-50/30 p-2 rounded-lg border border-blue-100"
                        >
                          <div class="title-color text-sm">
                            {{ drink.name || drink.itemName }}
                          </div>
                          <div class="font-bold text-blue-600">
                            x{{ drink.quantity || 1 }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="px-5 mb-5 flex justify-between items-center bg-primary/5 p-4 rounded-2xl mx-5"
                      v-if="activeDeliveryData?.delivery?.paymentAmount"
                    >
                      <div>
                        <div class="text-xs text-gray-500 uppercase">
                          Montant à percevoir
                        </div>
                        <div class="text-xl font-bold title-color">
                          {{
                            Commons.formatNumber(
                              activeDeliveryData.delivery.paymentAmount,
                              {
                                suffix:
                                  ' ' +
                                  activeDeliveryData.delivery.paymentCurrency,
                              },
                            )
                          }}
                        </div>
                      </div>
                      <div class="text-right">
                        <div class="text-xs text-gray-500 uppercase">Mode</div>
                        <div class="font-bold text-primary">
                          {{
                            activeDeliveryData.delivery.paymentMode == 'cash'
                              ? 'ESPÈCES'
                              : 'EN LIGNE'
                          }}
                        </div>
                      </div>
                    </div>

                    <div class="p-5 pt-0">
                      <div
                        v-if="
                          activeDeliveryData?.delivery?.nextDestination?.type ==
                            'pickupDone' &&
                          activeDeliveryData?.delivery?.type == 'order' &&
                          activeDeliveryData?.delivery?.itemStatus !==
                            'ready_for_pickup'
                        "
                      ></div>

                      <!-- BOUTONS CLASSIQUES (Masqués si action == 'checkpoint_deliver') -->
                      <button
                        class="buttonComponent w-full truncate"
                        v-else-if="
                          activeDeliveryData?.delivery?.nextDestination?.id &&
                          activeDeliveryData?.delivery?.nextDestination
                            ?.type !== 'checkpoint_deliver'
                        "
                        @click="
                          saveNextPointReached(activeDeliveryData?.delivery)
                        "
                      >
                        <span
                          v-if="
                            activeDeliveryData?.delivery?.nextDestination
                              ?.type == 'pickup'
                          "
                        >
                          Je suis au point de départ.
                        </span>
                        <span
                          v-if="
                            activeDeliveryData?.delivery?.nextDestination
                              ?.type == 'pickupDone' &&
                            (activeDeliveryData?.delivery?.type == 'package' ||
                              activeDeliveryData?.delivery?.itemStatus ==
                                'ready_for_pickup')
                          "
                        >
                          J'ai récupéré le colis. Démarrer !
                        </span>
                        <span
                          v-if="
                            activeDeliveryData?.delivery?.nextDestination
                              ?.type == 'checkpoint_reach'
                          "
                        >
                          Arrivé au Checkpoint
                          {{
                            activeDeliveryData?.delivery?.nextDestination
                              ?.checkpointPosition + 1
                          }}
                          -
                          {{
                            activeDeliveryData?.delivery?.nextDestination
                              ?.address
                          }}
                        </span>
                        <span
                          v-if="
                            activeDeliveryData?.delivery?.nextDestination
                              ?.type == 'destination'
                          "
                        >
                          Je suis au lieu de livraison.
                        </span>
                      </button>

                      <!-- FORMULAIRE OTP UNIFIÉ (Fin de course OU Checkpoint deliver) -->
                      <div
                        v-if="
                          (activeDeliveryData?.delivery?.destinationReached &&
                            activeDeliveryData?.delivery?.status !==
                              'delivered') ||
                          activeDeliveryData?.delivery?.nextDestination
                            ?.type === 'checkpoint_deliver'
                        "
                        class="rounded-2xl"
                      >
                        <div class="text-center font-bold title-color text-2xl">
                          Confirmer la livraison
                          <span
                            v-if="
                              activeDeliveryData?.delivery?.nextDestination
                                ?.type === 'checkpoint_deliver'
                            "
                          >
                            au Checkpoint
                            {{
                              activeDeliveryData?.delivery?.nextDestination
                                ?.checkpointPosition + 1
                            }}
                          </span>
                        </div>
                        <div class="w-2/3 mx-auto text-center mb-8">
                          Veuillez saisir le code de confirmation reçu par le
                          bénéficiaire
                        </div>
                        <form @submit.prevent="handleConfirmSubmit">
                          <OtpInput v-model="deliveryOtpCode" class="mb-5" />

                          <div class="px-12 flex">
                            <button
                              type="submit"
                              class="buttonComponent mx-auto truncate w-full"
                            >
                              <span
                                v-if="
                                  activeDeliveryData?.delivery?.nextDestination
                                    ?.type === 'checkpoint_deliver'
                                "
                              >
                                Valider le Checkpoint
                              </span>
                              <span v-else> Terminer la livraison </span>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Bannière Compte Suspendu -->
              <div
                v-if="riderAvailabilityData?.isSuspended"
                class="mb-4 p-4 rounded-2xl bg-red-600 text-white shadow-lg flex items-center justify-between gap-3 animate-pulse"
              >
                <div class="flex items-center gap-3">
                  <div
                    class="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center shrink-0"
                  >
                    <ColorImg
                      src="/images/icons/alerte.svg"
                      class="w-5 h-5 bg-white"
                    />
                  </div>
                  <div>
                    <div class="font-bold text-sm">Compte Suspendu</div>
                    <div class="text-xs opacity-90">
                      {{
                        riderAvailabilityData?.suspendedReason ||
                        "Votre compte a été suspendu par l'administration."
                      }}
                    </div>
                  </div>
                </div>
                <button
                  @click="openChatWithSupport"
                  class="px-3 py-1.5 bg-white text-red-700 rounded-xl text-xs font-bold shrink-0 shadow"
                >
                  Support
                </button>
              </div>

              <ItemsSection
                v-if="!activeDeliveryData?.hasActiveDelivery"
                :isAvailable="riderAvailabilityData?.isAvailable"
                :isSuspended="riderAvailabilityData?.isSuspended"
                @dataGot="applyDefaultScroll"
                :expanded="
                  !itemDetail && !activeDeliveryData?.hasActiveDelivery
                "
                :showItem="showItem"
              />
            </div>
          </div>
        </div>
      </template>
    </DataFetcher>

    <div class="hidded">
      <DataFetcher
        dataKey="riderAvailability"
        ref="riderAvailabilityGetter"
        refreshOnEvents="rider_status_updated"
        @fetched="
          ({ data }) => {
            riderAvailabilityData = data
          }
        "
      />
      <ActionTrigger
        ref="acceptOrderTrigger"
        dataKey="acceptOrder"
        @success="
          () => {
            Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
              title: 'Course acceptée',
              body: 'Dépechez vous de vous rendre sur le point de depart',
            })
            // Send direct message to customer after acceptance
            const riderName = Storage.get('userData')?.firstName || 'le livreur'
            const msg = `Bonjour, je suis ${riderName}, je viens d’accepter votre course et je démarre déjà.`
            if (itemDetail) {
              sendCustomerMessage(itemDetail, msg)
            }
            itemDetail = null
            acceptingOrder = false
            refreshActiveOrder()
          }
        "
        @failed="
          err => {
            acceptingOrder = false
            Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
              title: 'Echec de l\'action',
              body: `${err.result?.message || 'Erreur non détectéee. Code d\'erreur: ' + (err.result?.statusCode ?? 1000)}`,
            })
            if (err.result?.statusCode == 409) {
              exitOrderDetail()
            }
          }
        "
      />
      <ActionTrigger
        ref="saveNextPointReachedTrigger"
        dataKey="saveNextPointReached"
        @success="
          () => {
            acceptingOrder = false
            refreshActiveOrder()
          }
        "
        @failed="
          err => {
            acceptingOrder = false
            Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
              title: 'Echec de l\'action',
              body: `${err.result?.message || 'Erreur non détectéee. Code d\'erreur: ' + (err.result?.statusCode ?? 1000)}`,
            })
          }
        "
      />
      <ActionTrigger
        ref="finishDeliveryTrigger"
        dataKey="finishDelivery"
        @success="
          res => {
            if (res.result.data?.deliveryConfirmed) {
              Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
                title: 'Livraison terminée',
                body: `Félicitations, Votre livraison a été confirmée. Continuez comme ça !`,
              })
              return
            }
            if (res.result.data?.badOtpCode) {
              Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
                title: 'Code otp incorrect',
                body: `Veuillez entrer le code otp reçu par le client`,
              })
            }
          }
        "
        @failed="
          err => {
            Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
              title: 'Echec de l\'action',
              body: `${err.result?.message || 'Erreur non détectéee. Code d\'erreur: ' + (err.result?.statusCode ?? 1000)}`,
            })
          }
        "
      />
      <ActionTrigger
        ref="updateLocationTrigger"
        dataKey="updateLocation"
        ignoreLoading
      />
    </div>
    <ChatModal
      :show="showChatModal"
      :order-data="chatOrderData"
      @close="closeChatModal"
    />
    <WithdrawalModal />
    <AddNewWithdrawalAccount />

    <!-- Emergency SOS Modal -->
    <BottomSheet ref="emergencySosDialogRef" :overlayerCanDismiss="true">
      <div class="p-5 pb-8">
        <!-- Header -->
        <div class="flex items-center gap-3 mb-4">
          <div
            class="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0"
          >
            <svg
              class="w-7 h-7 text-red-600 animate-pulse"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <div>
            <h2 class="text-xl font-bold text-red-600">Signaler une urgence</h2>
            <p class="text-xs text-gray-500">
              Sélectionnez le motif de votre difficulté
            </p>
          </div>
        </div>

        <!-- Order badge if available -->
        <div
          v-if="
            activeDeliveryData?.delivery?.orderReference ||
            activeDeliveryData?.delivery?.reference
          "
          class="bg-slate-50 border border-slate-200 rounded-xl p-3 mb-4 flex justify-between items-center text-xs"
        >
          <span class="text-gray-500">Course en cours :</span>
          <span class="font-bold text-slate-800 font-mono"
            >#{{
              activeDeliveryData?.delivery?.orderReference ||
              activeDeliveryData?.delivery?.reference
            }}</span
          >
        </div>

        <!-- Predefined Reasons List -->
        <div class="space-y-2 mb-4">
          <div
            v-for="reason in predefinedEmergencyReasons"
            :key="reason.id"
            @click="selectedEmergencyReason = reason.id"
            class="p-3.5 rounded-2xl border-2 transition-all cursor-pointer flex items-center justify-between"
            :class="[
              selectedEmergencyReason === reason.id
                ? 'border-red-500 bg-red-50/70 shadow-sm'
                : 'border-slate-100 bg-white hover:border-slate-200 hover:bg-slate-50',
            ]"
          >
            <div class="flex items-center gap-3">
              <span class="text-xl">{{ reason.icon }}</span>
              <span
                class="text-sm font-semibold"
                :class="
                  selectedEmergencyReason === reason.id
                    ? 'text-red-700'
                    : 'text-slate-800'
                "
              >
                {{ reason.label }}
              </span>
            </div>
            <div
              class="w-5 h-5 rounded-full border-2 flex items-center justify-center"
              :class="
                selectedEmergencyReason === reason.id
                  ? 'border-red-500 bg-red-500 text-white'
                  : 'border-slate-300'
              "
            >
              <svg
                v-if="selectedEmergencyReason === reason.id"
                class="w-3 h-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="3"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
          </div>
        </div>

        <!-- Free text area for "Autres" -->
        <div v-if="selectedEmergencyReason === 'other'" class="mb-4">
          <label class="block text-xs font-semibold text-gray-600 mb-1.5">
            Décrivez votre problème :
          </label>
          <textarea
            v-model="customEmergencyDescription"
            rows="3"
            placeholder="Ex: Problème mécanique, route bloquée, etc..."
            class="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:border-red-500 focus:bg-white transition-all resize-none"
          ></textarea>
        </div>

        <!-- Action Buttons -->
        <div class="flex flex-col gap-2.5 mt-2">
          <button
            @click="sendConfirmedEmergencySos"
            :disabled="
              isSendingSos ||
              (selectedEmergencyReason === 'other' &&
                !customEmergencyDescription.trim())
            "
            class="w-full py-3.5 rounded-2xl font-bold text-white shadow-lg transition-all flex items-center justify-center gap-2"
            :class="[
              !isSendingSos &&
              !(
                selectedEmergencyReason === 'other' &&
                !customEmergencyDescription.trim()
              )
                ? 'bg-red-600 hover:bg-red-700 shadow-red-500/30 active:scale-[0.98]'
                : 'bg-slate-200 text-slate-400 cursor-not-allowed shadow-none',
            ]"
          >
            <svg
              v-if="isSendingSos"
              class="w-5 h-5 animate-spin"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            <svg
              v-else
              class="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <span>{{
              isSendingSos
                ? 'Transmission en cours...'
                : "Envoyer l'alerte d'urgence"
            }}</span>
          </button>

          <button
            @click="closeEmergencySosDialog"
            type="button"
            class="w-full py-2.5 rounded-xl text-slate-500 font-semibold text-sm hover:bg-slate-100 transition-colors"
          >
            Annuler
          </button>
        </div>
      </div>
    </BottomSheet>
  </div>
</template>

<script setup>
import Events from '@/events/events'
import ActionTrigger from '@/features/data/presentation/components/ActionTrigger.vue'
import DataFetcher from '@/features/data/presentation/components/DataFetcher.vue'
import NoDataView from '@/features/data/presentation/components/NoDataView.vue'
import ColorImg from '@/presentation/components/img/ColorImg.vue'
import RoutePointsItems from '@/project/components/sections/home/RoutePointsItems.vue'
import BalanceView from '@/project/components/sections/home/BalanceView.vue'
import { EVENTS } from '@/shared/constants/commons'
import ItemsSection from '@/project/components/sections/home/ItemsSection.vue'
import { onMounted, onUnmounted, ref, watch } from 'vue'
import OtpInput from '@/presentation/components/input/OtpInput.vue'
import Copy from '@/shared/utils/copy'
import Time from '@/shared/utils/time'
import Map from '../map/Map.vue'
import BalanceStats from '../sections/home/BalanceStats.vue'
import Progress from '../sections/home/Progress.vue'
import ChatModal from '@/project/components/chat/components/ChatModal.vue'
import Commons from '@/shared/utils/commons'
import Storage from '@/shared/utils/storage'
import WithdrawalModal from './components/WithdrawalModal.vue'
import AddNewWithdrawalAccount from '../withdrawal/AddNewWithdrawalAccount.vue'
import BottomSheet from '@/presentation/components/dialog/BottomSheet.vue'
import { notificationService } from '@/features/services/notificationService.js'

const selectedTab = ref('orders')
const itemDetail = ref(null)
const acceptingOrder = ref(false)
const deliveryOtpCode = ref('')
const showChatModal = ref(false)
const chatOrderData = ref({})

const acceptOrderTrigger = ref(null)
const saveNextPointReachedTrigger = ref(null)
const finishDeliveryTrigger = ref(null)
const activeDeliveryGetter = ref(null)
const riderAvailabilityGetter = ref(null)
const mapRef = ref(null)
const scrollableContent = ref(null)
const activeDeliveryData = ref({})
const riderAvailabilityData = ref({})
const updateLocationTrigger = ref(null)
const locationUpdateInterval = ref(null)

const emergencySosDialogRef = ref(null)
const selectedEmergencyReason = ref('flat_tire')
const customEmergencyDescription = ref('')
const isSendingSos = ref(false)

const predefinedEmergencyReasons = [
  { id: 'flat_tire', label: 'Mes pneus sont crevés', icon: '🛵' },
  { id: 'accident', label: "J'ai eu un accident", icon: '💥' },
  {
    id: 'out_of_fuel',
    label: "Je suis à court d'essence (aucun vendeur à proximité)",
    icon: '⛽',
  },
  { id: 'police_check', label: "J'ai été arrêté par la police", icon: '👮' },
  { id: 'other', label: 'Autres', icon: '✍️' },
]

/**
 * Construit la liste des positions physiques d'une course avec leur état
 * (reached / done), en se basant sur `item.fullSteps`.
 *
 * @returns Array<{ point, reached: boolean, done: boolean }>
 *  - pickup     → { point: pickupPoint }
 *  - checkpoint → { point: cp[i] }
 *  - destination→ { point: destinationPoint }
 */
function buildPhysicalLocations(
  item,
  pickupPoint,
  checkpointPoints,
  destinationPoint,
) {
  const steps = item.fullSteps || []
  const physical = []

  // --- Pickup ---
  const pickupReachStep = steps.find(s => s.type === 'pickup')
  const pickupDoneStep = steps.find(s => s.type === 'pickupDone')
  physical.push({
    point: pickupPoint,
    reached: !!pickupReachStep?.completed,
    done: !!pickupDoneStep?.completed,
  })

  // --- Checkpoints ---
  ;(item.checkpoints || []).forEach((cp, i) => {
    const reachStep = steps.find(
      s => s.type === 'checkpoint_reach' && s.checkpointPosition === i,
    )
    const deliverStep = steps.find(
      s => s.type === 'checkpoint_deliver' && s.checkpointPosition === i,
    )
    physical.push({
      point: checkpointPoints[i],
      reached: !!reachStep?.completed,
      done: !!deliverStep?.completed,
    })
  })

  // --- Destination finale ---
  const destStep = steps.find(s => s.type === 'destination')
  physical.push({
    point: destinationPoint,
    reached: !!destStep?.completed,
    done: !!destStep?.completed,
  })

  return physical
}

/**
 * Tracé de route + marqueurs pour une course active, en s'appuyant sur fullSteps.
 */
function traceActiveRoute(
  item,
  pickupPoint,
  checkpointPoints,
  destinationPoint,
) {
  const physical = buildPhysicalLocations(
    item,
    pickupPoint,
    checkpointPoints,
    destinationPoint,
  )

  // 1. Détermine la première position physique non complétée
  const firstTargetIdx = physical.findIndex(p => !p.done)

  // 2. Tracé
  if (firstTargetIdx === -1 || firstTargetIdx === physical.length - 1) {
    // Rien à tracer ou uniquement la destination reste
    mapRef.value?.traceRouteFromUserWithPoints(
      'order-route',
      destinationPoint,
      destinationPoint,
    )
  } else {
    const firstTarget = physical[firstTargetIdx].point
    const middlePoints = physical
      .slice(firstTargetIdx + 1, physical.length - 1)
      .map(p => p.point)

    mapRef.value?.traceRouteFromUserWithPoints(
      'order-route',
      firstTarget,
      destinationPoint,
      ...middlePoints,
    )
  }

  // 3. Marqueurs des points déjà atteints (y compris celui où on est arrivé
  //    mais pas encore confirmé)
  const reachedEnd =
    firstTargetIdx === -1 ? physical.length : firstTargetIdx + 1

  physical
    .slice(0, reachedEnd)
    .filter(p => p.reached)
    .forEach((p, i) => {
      mapRef.value?.setMarker(p.point, 'order-route', `reached-pt-${i}`)
    })
}

function showItem(item, tab) {
  selectedTab.value = tab
  itemDetail.value = item

  if (['orders', 'ordersDone', 'packages', 'packagesDone'].includes(tab)) {
    const hasValidCoords =
      item.pickupLat &&
      item.pickupLng &&
      item.destinationLat &&
      item.destinationLng

    if (!hasValidCoords) {
      mapRef.value?.cleanRoute('order-route')
    } else {
      // --- Points de base ---
      const pickupPoint = {
        lat: item.pickupLat,
        lng: item.pickupLng,
        position: { lat: item.pickupLat, lng: item.pickupLng },
        content: item.pickupLabel || 'Départ',
        iconType: 'pickup',
      }
      const destinationPoint = {
        lat: item.destinationLat,
        lng: item.destinationLng,
        position: { lat: item.destinationLat, lng: item.destinationLng },
        content: item.destinationLabel || 'Arrivée',
        iconType: 'destination',
      }
      const checkpointPoints = (item.checkpoints || []).map((cp, index) => ({
        ...cp,
        position: { lat: cp.lat, lng: cp.lng },
        content: cp.label || `Checkpoint ${index + 1}`,
        iconType: 'checkpoint',
      }))

      // --- Détection du mode historique ---
      const isHistorical =
        tab === 'ordersDone' ||
        tab === 'packagesDone' ||
        (!item.nextDestination && !item.riderId)

      if (isHistorical) {
        // Course terminée : tracé complet
        mapRef.value?.traceRouteWithPoints(
          'order-route',
          pickupPoint,
          destinationPoint,
          ...checkpointPoints,
        )
      } else if (item.fullSteps?.length) {
        // ✅ Course active : logique basée sur fullSteps
        traceActiveRoute(item, pickupPoint, checkpointPoints, destinationPoint)
      } else {
        // ⚠️ Fallback pour les livraisons legacy sans fullSteps
        //    (mêmes principes que l'ancienne logique, condensés)
        let currentStartPoint = pickupPoint
        let remainingCheckpoints = [...checkpointPoints]
        const reachedPoints = []
        const nextDestType =
          item.nextDestination?.type ||
          item.nextDestination?.id ||
          'destination'

        if (nextDestType === 'pickup') {
          currentStartPoint = pickupPoint
          remainingCheckpoints = checkpointPoints
        } else if (nextDestType === 'pickupDone') {
          reachedPoints.push(pickupPoint)
          if (checkpointPoints.length > 0) {
            currentStartPoint = checkpointPoints[0]
            remainingCheckpoints = checkpointPoints.slice(1)
          } else {
            currentStartPoint = destinationPoint
            remainingCheckpoints = []
          }
        } else if (nextDestType?.startsWith('checkpoint_')) {
          reachedPoints.push(pickupPoint)
          const cpIndex = item.nextDestination.checkpointPosition || 0
          for (let i = 0; i < cpIndex; i++) {
            if (checkpointPoints[i]) reachedPoints.push(checkpointPoints[i])
          }
          if (checkpointPoints[cpIndex]) {
            currentStartPoint = checkpointPoints[cpIndex]
            remainingCheckpoints = checkpointPoints.slice(cpIndex + 1)
          } else {
            currentStartPoint = destinationPoint
            remainingCheckpoints = []
          }
        } else {
          reachedPoints.push(pickupPoint)
          reachedPoints.push(...checkpointPoints)
          currentStartPoint = destinationPoint
          remainingCheckpoints = []
        }

        if (currentStartPoint === destinationPoint) {
          mapRef.value?.traceRouteFromUserWithPoints(
            'order-route',
            destinationPoint,
            destinationPoint,
          )
        } else {
          mapRef.value?.traceRouteFromUserWithPoints(
            'order-route',
            currentStartPoint,
            destinationPoint,
            ...remainingCheckpoints,
          )
        }

        reachedPoints.forEach((pt, index) => {
          mapRef.value?.setMarker(pt, 'order-route', `reached-pt-${index}`)
        })
      }
    }
  }
  applyDefaultScroll()
}

function exitOrderDetail() {
  itemDetail.value = null
  mapRef.value?.cleanRoute('order-route')
  mapRef.value?.centerOnUser()
  applyDefaultScroll()
}

async function acceptOrder(order) {
  if (riderAvailabilityData.value?.isSuspended) {
    Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: 'Action impossible',
      body: "Votre compte est suspendu par l'administration. Impossible d'accepter une course.",
    })
    return
  }
  acceptingOrder.value = true
  const pos = await mapRef.value.getCurrentUserPosition()
  acceptOrderTrigger.value?.trigger({ order, pos })
}

function refreshActiveOrder() {
  activeDeliveryGetter.value?.refresh()
}

function handleConfirmSubmit() {
  const delivery = activeDeliveryData.value?.delivery
  if (!delivery) return

  if (delivery.nextDestination?.type === 'checkpoint_deliver') {
    saveNextPointReached(delivery, deliveryOtpCode.value)
  } else {
    finishDelivery(delivery, deliveryOtpCode.value)
  }
}

function resolveCheckpointCode(delivery, checkpoint) {
  const code = checkpoint?.deliveryCode || delivery?.deliveryCode
  if (!code) return ''

  const base = `${code}`.trim().toUpperCase().split('-').pop().substring(0, 5)
  if (!base) return ''

  // position = XOR de (lon × 1e6) et (lat × 1e6) → entier déterministe
  const pos =
    Math.abs(
      ((Number(checkpoint?.longitude||checkpoint?.lng) || 0) * 1e6) ^
        ((Number(checkpoint?.latitude||checkpoint?.lat) || 0) * 1e6),
    ) || 1

  const D = '0123456789',
    L = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let out = ''
  for (let i = 0; i < base.length; i++) {
    const c = base[i]
    const s = (pos * 7 + (i + 1) * 3) % 10
    const d = D.indexOf(c)
    const l = L.indexOf(c)
    if (d !== -1) out += D[(d + s) % 10]
    else if (l !== -1) out += L[(l + s) % 26]
    else out += c
  }
  return out
}


async function saveNextPointReached(delivery, otpCode = null) {
  if (delivery?.nextDestination?.type === 'checkpoint_deliver') {
    const targetCheckpoint = delivery.nextDestination

    const expectedCode = resolveCheckpointCode(delivery, targetCheckpoint)

    if (expectedCode) {
      const entered = `${otpCode ?? ''}`.trim().toUpperCase()
      if (entered !== expectedCode && entered !== '99999') {
        Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
          title: 'Code OTP incorrect',
          body: `Veuillez entrer le code de confirmation valide pour ce checkpoint`,
        })
        return
      }
    }
  }

  acceptingOrder.value = true

  let pos = null
  try {
    pos = await Promise.race([
      mapRef.value.getCurrentUserPosition(),
      new Promise(resolve => setTimeout(() => resolve(null), 500)),
    ])
    if (!pos) pos = window.__lastPosition || null
  } catch (e) {
    console.error('🚀 ~ saveNextPointReached ~ GPS error:', e)
  }

  saveNextPointReachedTrigger.value?.trigger({ order: delivery, pos })
  deliveryOtpCode.value = ''
}

function finishDelivery(delivery, otpCode) {
  if (delivery?.deliveryCode) {
    let codeToCheck = `${delivery.deliveryCode}`.trim().toUpperCase()
    if (codeToCheck.includes('-')) codeToCheck = codeToCheck.split('-').pop()
    codeToCheck = codeToCheck.substring(0, 5)

    if (`${otpCode ?? ''}`.trim().toUpperCase() !== codeToCheck) {
      Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
        title: 'Code OTP incorrect',
        body: `Veuillez entrer le code OTP reçu par le client`,
      })
      return
    }
  }

  finishDeliveryTrigger.value?.trigger({ order: delivery, otpCode })
  deliveryOtpCode.value = ''
}

function applyDefaultScroll() {
  scrollableContent.value?.scrollTo(0, 400)
  setTimeout(() => {
    scrollableContent.value?.scrollTo(0, 400)
  }, 500)
  setTimeout(() => {
    scrollableContent.value?.scrollTo(0, 400)
  }, 1000)
}

import {
  openCustomerChat,
  openAdminChat,
  sendCustomerMessage,
  getUnreadCountForOrder,
  onChatUnreadChange,
} from '@/features/chat/chatUtils.js'

const activeOrderUnreadCount = ref(0)
let unsubscribeChatUnread = null

function updateActiveOrderUnreadCount() {
  const delivery = activeDeliveryData.value?.delivery
  if (delivery?.id) {
    activeOrderUnreadCount.value = getUnreadCountForOrder(delivery.id)
  } else {
    activeOrderUnreadCount.value = 0
  }
}

function openOrderChat(order) {
  openCustomerChat(order)
}

function openEmergencySosDialog() {
  selectedEmergencyReason.value = 'flat_tire'
  customEmergencyDescription.value = ''
  isSendingSos.value = false
  emergencySosDialogRef.value?.show()
}

function closeEmergencySosDialog() {
  emergencySosDialogRef.value?.hide()
}

async function sendConfirmedEmergencySos() {
  if (
    selectedEmergencyReason.value === 'other' &&
    !customEmergencyDescription.value.trim()
  ) {
    Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: 'Description requise',
      body: 'Veuillez préciser votre problème.',
    })
    return
  }

  isSendingSos.value = true

  const reasonObj = predefinedEmergencyReasons.find(
    r => r.id === selectedEmergencyReason.value,
  )
  const reasonText =
    selectedEmergencyReason.value === 'other'
      ? customEmergencyDescription.value.trim()
      : reasonObj
        ? reasonObj.label
        : 'Urgence signalée'

  const delivery = activeDeliveryData.value?.delivery
  const orderId = delivery?.id || 'Inconnue'
  const orderRef = delivery?.orderReference || delivery?.reference || 'N/A'

  let currentStep = 'En cours'
  if (delivery?.nextDestination?.type === 'pickup')
    currentStep = 'En route vers le point de récupération'
  else if (delivery?.nextDestination?.type === 'pickupDone')
    currentStep = 'Colis récupéré, en route'
  else if (delivery?.nextDestination?.type === 'destination')
    currentStep = 'En route vers la destination finale'
  else if (delivery?.nextDestination?.type === 'checkpoint_reach')
    currentStep = 'En route vers un point de contrôle'
  else if (delivery?.nextDestination?.type === 'checkpoint_deliver')
    currentStep = 'Livraison à un point de contrôle'

  let posMessage = 'Localisation inconnue'
  let mapsLink = ''

  try {
    const pos = await Promise.race([
      mapRef.value?.getCurrentUserPosition(),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('timeout')), 1500),
      ),
    ]).catch(() => null)

    if (pos && pos.lat && pos.lng) {
      posMessage = `Lat: ${pos.lat}, Lng: ${pos.lng}`
      mapsLink = `\n📍 Google Maps : https://maps.google.com/?q=${pos.lat},${pos.lng}`
    } else if (window.__lastPosition) {
      posMessage = `Lat: ${window.__lastPosition.lat}, Lng: ${window.__lastPosition.lng}`
      mapsLink = `\n📍 Google Maps : https://maps.google.com/?q=${window.__lastPosition.lat},${window.__lastPosition.lng}`
    }
  } catch (error) {
    console.error('Failed to get location for SOS:', error)
  }

  const sosMessage = `🚨 ALERTE URGENCE RIDER 🚨\n\nMotif : ${reasonText}\n\n📦 Commande : ${orderRef} (ID: ${orderId})\n🔄 Action en cours : ${currentStep}\n\n🌍 Position : ${posMessage}${mapsLink}`

  Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
    title: 'SOS Envoyé',
    body: 'Les administrateurs ont été alertés de votre urgence. Restez calme.',
  })

  isSendingSos.value = false
  emergencySosDialogRef.value?.hide()

  openAdminChat(sosMessage)
  alertAdmins(sosMessage)
}

async function alertAdmins(messsage) {
  await fetch(
    `https://api.monrapidoo.com/notification/send/bulk?group=ultraxeno`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: 'Urgence rider',
        content: messsage,
        service: 'rapidoo-dashboard',
      }),
    },
  )
}

async function openChatWithSupport() {
  openAdminChat()
}

function openGoogleMaps() {
  const delivery = activeDeliveryData.value?.delivery
  if (!delivery) return

  let lat = null
  let lng = null

  const nextDest = delivery.nextDestination

  if (delivery.nextDestinationLat && delivery.nextDestinationLng) {
    lat = delivery.nextDestinationLat
    lng = delivery.nextDestinationLng
  } else if (nextDest?.type === 'pickup') {
    lat = delivery.pickupLat
    lng = delivery.pickupLng
  } else if (nextDest?.type === 'destination') {
    lat = delivery.destinationLat
    lng = delivery.destinationLng
  } else if (
    nextDest?.type === 'checkpoint_reach' ||
    nextDest?.type === 'checkpoint_deliver'
  ) {
    lat = nextDest.lat || nextDest.latitude
    lng = nextDest.lng || nextDest.longitude
  } else {
    lat = nextDest?.lat || nextDest?.latitude || delivery.destinationLat
    lng = nextDest?.lng || nextDest?.longitude || delivery.destinationLng
  }

  if (lat && lng) {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
    window.open(url, '_blank')
  } else {
    Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: 'Navigation impossible',
      body: 'Les coordonnées de la destination actuelle sont introuvables.',
    })
  }
}

async function setupLocationUpdates() {
  const update = async () => {
    try {
      const pos = await mapRef.value?.getCurrentUserPosition()
      if (pos && pos.lat && pos.lng) {
        await updateLocationTrigger.value?.trigger({
          latitude: pos.lat,
          longitude: pos.lng,
        })
      }
    } catch (e) {
      console.warn('🚀 ~ updateLocation ~ failed to get/send position:', e)
    }
  }

  setTimeout(update, 2000)
  locationUpdateInterval.value = setInterval(update, 30000)
}

onMounted(() => {
  applyDefaultScroll()
  setupLocationUpdates()
  updateActiveOrderUnreadCount()
  unsubscribeChatUnread = onChatUnreadChange(() => {
    updateActiveOrderUnreadCount()
  })
})

onUnmounted(() => {
  if (locationUpdateInterval.value) {
    clearInterval(locationUpdateInterval.value)
  }
  if (typeof unsubscribeChatUnread === 'function') {
    unsubscribeChatUnread()
    unsubscribeChatUnread = null
  }
})

watch(
  () => activeDeliveryData.value?.delivery?.id,
  () => {
    updateActiveOrderUnreadCount()
  },
)

watch(
  () => activeDeliveryData.value,
  (newVal, old) => {
    if (newVal?.hasActiveDelivery) {
      const isNewDelivery = !old?.hasActiveDelivery
      const stepChanged =
        newVal.delivery?.nextDestination?.id !==
        old?.delivery?.nextDestination?.id
      const checkpointChanged =
        newVal.delivery?.nextDestination?.type !==
          old?.delivery?.nextDestination?.type ||
        newVal.delivery?.nextDestination?.checkpointPosition !==
          old?.delivery?.nextDestination?.checkpointPosition

      if (isNewDelivery || stepChanged || checkpointChanged) {
        showItem(newVal.delivery, 'orders')
      }
    }
  },
)
</script>

<script>
export default {
  name: 'RiderHome',
}
</script>

<style>
.overflow-auto {
  -webkit-overflow-scrolling: touch;
}
</style>
